import { CostCenterFormType } from '@pages/cost-centers/utils';
import { Typography, Button } from '@ui/components';
import { FormTableList } from '@shared/components';
import { Plus } from '@ui/components/icons';
import { FC } from 'react';

import { CostCenterCreateDocumentsReceiverDialog } from './cost-center-create-documents-receiver-dialog/cost-center-create-documents-receiver-dialog';
import { useCostCenterDocumentsForm } from './use-cost-center-documents-form';

export const CostCenterDocumentsForm: FC<{ form: CostCenterFormType; editMode?: boolean }> = ({
  form,
}) => {
  const recipients = form.watch('recipients');
  const { tableList, t } = useCostCenterDocumentsForm(recipients);

  return (
    <div className="pb-4 space-y-4">
      <Typography variant="labelMediumBold">{t('COST_CENTERS.DOCUMENTS_TITLE')}</Typography>
      <FormTableList
        {...tableList}
        text={{
          searchPlaceholder: t('COST_CENTERS.TABLE_SEARCH_PLACEHOLDER'),
          removeButtonText: t('COST_CENTERS.DOCUMENTS_RECEIVER_ASSIGN_REMOVE'),
          tableNoResults: (
            <div className="flex flex-col gap-1">
              <Typography variant="labelMediumMedium">
                {t('COST_CENTERS.DOCUMENTS_RECEIVER_ASSIGN_NO_RESULT')}
              </Typography>
              <Typography variant="labelSmallBook" className="text-weak">
                {t('COST_CENTERS.DOCUMENTS_RECEIVER_ASSIGN_NO_RESULT_SUBLINE')}
              </Typography>
            </div>
          ),
          title: t('COST_CENTERS.DOCUMENTS_RECEIVERS_TITLE'),
          selectedRows: (count) =>
            t('COST_CENTERS.DOCUMENTS_RECEIVER_ASSIGN_SELECTED_ROWS', {
              postProcess: 'interval',
              count,
            }),
        }}
        formControl={form.control}
        name="recipients"
      />
      <CostCenterCreateDocumentsReceiverDialog
        setReceiver={(receiver) => {
          const recipients = form.getValues('recipients') || [];
          form.setValue('recipients', [...recipients, receiver.email]);
        }}
        recipients={recipients}
      >
        <Button variant="secondary" type="button">
          <Plus />
          {t('COST_CENTERS.DOCUMENTS_RECEIVER_ADD')}
        </Button>
      </CostCenterCreateDocumentsReceiverDialog>
    </div>
  );
};
